module.exports = __webpack_public_path__ + "img/avatar.74c4cbfb.png";